import { createAction } from '@reduxjs/toolkit';
import { ApplicationState } from './application.reducer';
import { PopupContent } from '../../types/common/popup-content';
import { ChainId } from '@plasma/plasmaswap-sdk';

export const updateBlock = createAction<{ chainId: number; block: ApplicationState['block'][number] }>('application/updateBlock');
export const addPopup = createAction<{ key?: string; removeAfterMs?: number | null; content: PopupContent }>('application/addPopup');
export const setDefaultChainId = createAction<ChainId>('application/setDefaultChainId');
